module.exports = __webpack_public_path__ + "img/img-shipin-s2-tuya.5e66b3b4.png";